import { render, staticRenderFns } from "./MsgBar.vue?vue&type=template&id=2755ab31&"
import script from "./MsgBar.vue?vue&type=script&lang=js&"
export * from "./MsgBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports